module.exports = __webpack_public_path__ + "static/img/H25.c4e9e89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H25.png
// module id = mlRj
// module chunks = 0